var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 12,
    viewBox: "0 0 17 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.62579 9.54478L1.70679 5.62578C1.51926 5.43831 1.26495 5.33299 0.999786 5.33299C0.734622 5.33299 0.480314 5.43831 0.292786 5.62578C0.105315 5.81331 0 6.06762 0 6.33278C0 6.59794 0.105315 6.85225 0.292786 7.03978L4.21179 10.9588C4.39751 11.1446 4.61803 11.292 4.86073 11.3925C5.10344 11.4931 5.36357 11.5448 5.62629 11.5448C5.889 11.5448 6.14914 11.4931 6.39184 11.3925C6.63454 11.292 6.85506 11.1446 7.04079 10.9588L16.2928 1.70678C16.4803 1.51926 16.5856 1.26495 16.5856 0.999785C16.5856 0.734621 16.4803 0.480313 16.2928 0.292786V0.292786C16.1053 0.105315 15.851 0 15.5858 0C15.3206 0 15.0663 0.105315 14.8788 0.292786L5.62579 9.54478Z",
    fill: "#374957"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.62579 9.54478L1.70679 5.62578C1.51926 5.43831 1.26495 5.33299 0.999786 5.33299C0.734622 5.33299 0.480314 5.43831 0.292786 5.62578C0.105315 5.81331 0 6.06762 0 6.33278C0 6.59794 0.105315 6.85225 0.292786 7.03978L4.21179 10.9588C4.39751 11.1446 4.61803 11.292 4.86073 11.3925C5.10344 11.4931 5.36357 11.5448 5.62629 11.5448C5.889 11.5448 6.14914 11.4931 6.39184 11.3925C6.63454 11.292 6.85506 11.1446 7.04079 10.9588L16.2928 1.70678C16.4803 1.51926 16.5856 1.26495 16.5856 0.999785C16.5856 0.734621 16.4803 0.480313 16.2928 0.292786V0.292786C16.1053 0.105315 15.851 0 15.5858 0C15.3206 0 15.0663 0.105315 14.8788 0.292786L5.62579 9.54478Z",
    fill: "url(#paint0_linear_1148_1499)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1148_1499",
    x1: 16.5856,
    y1: -5.91965e-7,
    x2: -1.64268,
    y2: 7.61026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93B4BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A677B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedBlue);
export default __webpack_public_path__ + "static/media/checked-blue.3f6d65dad3485d4ba347f3eb60a68cfe.svg";
export { ForwardRef as ReactComponent };